import ResizeObserver from 'resize-observer-polyfill';
import $ from 'jquery';
import { template } from 'lodash';

export default class PrimaryNav {
  constructor($header) {
    this.$nav = $header.find('.js-header-primary-nav');
  }

  init() {
    if (!this.$nav.length) {
      return;
    }

    document.fonts.ready
    .then(() => {
      this.findElements();

      this.$nav.addClass('is-active');
      this.$navList.addClass('is-steady');

      const resizeObserver = new ResizeObserver(() => {
        if (window.matchMedia('(min-width: 600px)').matches) {
          this.calculateNav();
        }
      });

      resizeObserver.observe(this.$nav[0]);
    })
    .catch(() => {
      console.error('Error during font loading');
    });
  }

  findElements() {
    this.$navList = this.$nav.find('.js-header-primary-nav-list');
    this.$navItems = this.$navList.find('.js-header-primary-nav-item');

    this.$more = this.$nav.find('.js-header-primary-nav-more');
    this.$moreList = this.$more.find('.js-header-primary-nav-more-list');
    this.moreItemTemplateString = this.$moreList.html();
  }

  calculateNav() {
    let hiddenItems = [];

    let itemsWidth = this.$more.outerWidth(true);

    const listWidth = this.$navList.outerWidth();

    let isNavFull = false;

    this.$navItems.each((_, navItem) => {
      const $navItem = $(navItem);

      if ($navItem.is(this.$more)) return;

      if (!isNavFull && (listWidth >= itemsWidth + $navItem.outerWidth(true))) {
        itemsWidth += $navItem.outerWidth(true);

        if ($navItem.hasClass('is-hidden')) {
          $navItem.removeClass('is-hidden');
        }
      } else {
        isNavFull = true;

        if (!$navItem.hasClass('is-hidden')) {
          $navItem.addClass('is-hidden');
        }

        const $subItems = $navItem.find('ul > li');

        if ($subItems.length) {
          hiddenItems.push(...$subItems.toArray());
        } else {
          hiddenItems.push($navItem[0]);
        }
      }
    });

    if (hiddenItems.length) {
      const interpolate = /\[\[([\s\S]+?)\]\]/g;

      hiddenItems = hiddenItems
        .map((item) => {
          const $item = $(item);

          return template(
            this.moreItemTemplateString,
            { interpolate },
          )({
            className: $item.data('selected') ? 'is-selected' : '',
            accessRole: $item.data('access-role'),
            href: $item.find('a').first().attr('href'),
            text: $item.find('a > span').first().text(),
          });
        });

      if (this.$more.hasClass('is-invisible')) {
        this.$more.removeClass('is-invisible');
      }
    } else if (!this.$more.hasClass('is-invisible')) {
      this.$more.addClass('is-invisible');
    }

    this.$moreList.html(hiddenItems.join(''));

    this.$navList.addClass('is-visible');
  }
}
